import client from '@/utils/client'

const faForwardSVG = '<svg aria-hidden="true" data-prefix="fas" data-icon="forward" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="ctl svg-inline--fa fa-forward fa-w-16"><path data-v-b53fc01e="" fill="currentColor" d="M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z" class=""></path></svg>'
const faBackwardSVG = '<svg aria-hidden="true" data-prefix="fas" data-icon="backward" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="ctl svg-inline--fa fa-backward fa-w-16"><path data-v-b53fc01e="" fill="currentColor" d="M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z" class=""></path></svg>'

// reasonable defaults to fall back on
var currentHost = 'dacasts3-vh.akamaihd.net'
var currentType = 'i'

const playlistButtonEvents = ['click', 'touchend']

export async function getNewSrc (player, newVideo) {
  if (!player) return null

  const theo = player.getPlayerInstance()
  if (!theo) return null

  const contentId = newVideo.dacast_content_id
  if (!contentId) return null

  if (theo.src) {
    const m = theo.src.match(/^(https?:)?\/\/([^/]+)\/([iz])\/secure/)

    if (m) {
      currentHost = m[2]
      currentType = m[3]
    } else {
      console.log('[player:getNewSrc] can\'t get stream type and host from current src, using default/old')
    }
  } else {
    console.log('[player:getNewSrc] current src not defined, using default/old stream type/host')
  }

  const contentPath = contentId.replace(/_/g, '/')
  const tokenResponse = await client.get(`https://services.dacast.com/token/${currentType}/b/${contentPath}`)
  const token = tokenResponse.data.token

  const info = newVideo.dacast_video_details
  const uri = (currentType === 'i') ? info.hls : info.hds

  let src = '//' + currentHost + uri + token
  src = src.replace(/\.raw,/, '.mp4,')

  return src
}

function createPlayerButton (theo, name) {
  const videojs = window.THEOplayer.videojs

  let CustomComponent = videojs.getComponent(name)
  if (CustomComponent !== undefined) return CustomComponent

  const Button = window.THEOplayer.videojs.getComponent('Button')
  CustomComponent = window.THEOplayer.videojs.extend(Button, {
    constructor () {
      Button.apply(this, arguments)
    },
    buildCSSClass () {
      return 'vjs-control vjs-button videojs-custom-button'
    }
  })

  window.THEOplayer.videojs.registerComponent(name, CustomComponent)
}

export function addPlaylistButtons (player, onPrev = () => {}, onNext = () => {}) {
  if (!player) return

  if (!window.THEOplayer) return

  const theo = player.getPlayerInstance()
  if (!theo) return
  console.log('[player] adding previous/next buttons to dacast player')

  createPlayerButton(theo, 'PrevButton')
  createPlayerButton(theo, 'NextButton')

  let btnPrev = theo.ui.getChild('controlBar').addChild('PrevButton', {})
  btnPrev.el().innerHTML = faBackwardSVG
  playlistButtonEvents.forEach(event => {
    btnPrev.el().addEventListener(event, onPrev)
  })

  let btnNext = theo.ui.getChild('controlBar').addChild('NextButton', {})
  btnNext.el().innerHTML = faForwardSVG
  playlistButtonEvents.forEach(event => {
    btnNext.el().addEventListener(event, onNext)
  })
  window.theo = theo
  window.btnNext = btnNext
}

export function removePlaylistButtonsListener (player, onPrev = () => {}, onNext = () => {}) {
  if (!player) return

  if (!window.THEOplayer) return

  const theo = player.getPlayerInstance()
  if (!theo) return

  let controlBar = theo.ui.getChild('controlBar')
  let btnPrev = controlBar.getChild('PrevButton').el()
  playlistButtonEvents.forEach(event => {
    btnPrev.removeEventListener(event, onPrev)
  })
  let btnNext = controlBar.getChild('NextButton').el()
  playlistButtonEvents.forEach(event => {
    btnNext.removeEventListener(event, onNext)
  })
  window.theo = theo
}

export function addPlaylistButtonsListener (player, onPrev = () => {}, onNext = () => {}) {
  if (!player) return

  if (!window.THEOplayer) return

  const theo = player.getPlayerInstance()
  if (!theo) return

  let controlBar = theo.ui.getChild('controlBar')
  let btnPrev = controlBar.getChild('PrevButton').el()
  playlistButtonEvents.forEach(event => {
    btnPrev.addEventListener(event, onPrev)
  })
  let btnNext = controlBar.getChild('NextButton').el()
  playlistButtonEvents.forEach(event => {
    btnNext.addEventListener(event, onNext)
  })
  window.theo = theo
}

export function addVideoDuration (player) {
  if (!player) return

  if (!window.THEOplayer) return

  const theo = player.getPlayerInstance()
  if (!theo) return
  console.log('[player] adding video duration to dacast player')

  // Remove Chrome Cast Button
  theo.ui.controlBar.removeChild('ChromecastButton')
  theo.ui.controlBar.removeChild('AirplayButton')
  // Add these since dacast don't show these by default
  theo.ui.controlBar.addChild('TimeDivider', {}, 6)
  theo.ui.controlBar.addChild('DurationDisplay', {}, 7)
  window.theo = theo
}



// WEBPACK FOOTER //
// ./src/utils/dacast.js